import React, {useState} from "react";
import {defaultThumbnail} from "../WooCommerce/wooConfig";
import Button from '../Elements/Button';
import WishlistButton from '../Elements/WishlistButton';
import {ButtonStyles} from '../Elements/consts';
import QtyButton from "../Elements/QtyButton";
import addToCart from "../Functions/AddToCart";
import SvgLink from '../SVG';
import {FONTELLO_FONTAWESOME_BASKET, FONTELLO_MODERNPICS_OK} from '../SVG/consts';
import ReviewRating from "./ReviewRating";
import LoadSpinner from "../Elements/LoadSpinner";

function SaleProduct({name, image, price, regularPrice, link, databaseId, reviews, reviewCount, type, simpleLayout, useSimpleContext}) {
    const [productQty, setProductQty] = useState(1);
    const [addedToCart, setAddedToCart] = useState();
    return (
        <li>
            <div className="product">
                <a href={link}>
                    <div className="product-image">
                        <picture>
                            <source type="image/webp" srcSet={`${image ? image.sourceUrl : defaultThumbnail}.webp`}/>
                            <img loading="lazy" src={image ? image.sourceUrl : defaultThumbnail} alt={name} />
                        </picture>
                    </div>
                    <h2>{name}</h2>
                </a>
                {reviews && reviewCount > 0 && <ReviewRating averageRating={reviews.averageRating} reviewCount={reviewCount} />}
                {!simpleLayout &&
                <>
                    <div className="product-pricing">
                            <span className="product-price">
                                {(price||regularPrice) && <>
                                    <span className="product-price-type">
                                        {type === 'VARIABLE' && 'STARTING FROM'}
                                    </span>
                                    <span className="product-price-amount">{price||regularPrice}</span>
                                </>}
                            </span>
                        {(type === 'SIMPLE' && !simpleLayout) && <QtyButton productQty={productQty} setProductQty={setProductQty} />}
                    </div>
                    {addedToCart && addedToCart.error && <small className="error">There was an error adding to cart, please reload the page and try again</small>}
                    <div className="product-buttons">
                        {type === 'SIMPLE' ?
                            <>
                                {addedToCart && addedToCart.loading ? <LoadSpinner/> :
                                    addedToCart && addedToCart.added ? <span className="product-added">Added to Basket <SvgLink {...FONTELLO_MODERNPICS_OK} /></span> :
                                        <Button style={ButtonStyles.basket} onClick={e => addToCart(e, databaseId, productQty, setAddedToCart)}>
                                            <SvgLink {...FONTELLO_FONTAWESOME_BASKET} />
                                            Add to Basket
                                        </Button>
                                }
                            </> :
                            <Button style={ButtonStyles.secondary} href={link}>
                                {type === 'BOOKING' ? 'Make Booking' : 'View Product'}
                            </Button>
                        }
                        <WishlistButton databaseId={databaseId} />
                    </div>
                </>
                }
            </div>
        </li>
    )
}

export default SaleProduct;